import React, { useContext, useEffect } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useContentToggle from "../content_toggles/useContentToggle";

const ElementSettingsNavigation = (props) => {
  const [contextData, builder, setContextData] = useContext(VariantContextData);
  const { ContentToggle } = useContentToggle();

  let website = contextData.objects.website;
  let variant = contextData.objects.variant;
  let element = builder.selected().object;

  const navigations = {
    ...(website.navigations || {}),
  };
  if (element.website_navigation && element.website_navigation.id) {
    navigations[element.website_navigation.id] =
      navigations[element.website_navigation.id] || element.website_navigation;
  }

  const selectedNavId = element.options["website-navigation-id"];

  let custom_content_items = Object.values(variant.content_toggle_items)
    .filter(
      (item) => item.element_id == element.id && item.toBeDeleted !== true
    )
    .sort((a, b) => a.position - b.position);

  let controlStyle = element.options["control-style"]
    ? element.options["control-style"]
    : "width";

  let controlStyleMobile = element.options["control-style-mobile"]
    ? element.options["control-style-mobile"]
    : controlStyle;

  useEffect(() => {
    if (custom_content_items[0]) {
      ContentToggle.sortableStart(custom_content_items[0]);
    }
  });

  const createCustomContent = () => {
    const customPositions = custom_content_items.map(
      (item) => item.position || 0
    );
    const maxPosition = Math.max(...customPositions, 0);

    builder.create(
      "content_toggle_items",
      {
        position: maxPosition + 1,
        element_id: element.id,
        content: `Custom Content ${custom_content_items.length + 1}`,
      },
      {
        callback: (content_toggle_item) => {
          setContextData((prevData) => {
            let newContextData = { ...prevData };
            newContextData.objects.variant.sections[
              content_toggle_item.section.id
            ] = content_toggle_item.section;
            return newContextData;
          });
        },
      }
    );
  };

  return (
    <React.Fragment>
      <VariantBuilderSetting
        object={element}
        setting_name="[options][nav-layout]"
        setting_type="navigation_layout"
        object_type="elements"
        object_id={element.id}
        label="Navigation Layout"
        value={
          element.options["nav-layout"] ? element.options["nav-layout"] : ""
        }
        show_reset={true}
      />

      <VariantBuilderSetting
        object={element}
        setting_name="[options][nav-logo-show]"
        setting_type="checkbox"
        object_type="elements"
        object_id={element.id}
        label="Show Logo"
        value={
          element.options["nav-logo-show"]
            ? element.options["nav-logo-show"]
            : "true"
        }
      />

      <VariantBuilderSetting
        object={element}
        setting_name="[options][logo-style]"
        setting_type="dropdown"
        object_type="elements"
        object_id={element.id}
        label="Logo Style"
        value={
          element.options["logo-style"]
            ? element.options["logo-style"]
            : variant.options["logo-style"]
            ? variant.options["logo-style"]
            : null
        }
        placeholder={variant.options["logo-style"]}
        options={[
          { value: "dark", text: "Dark Brand Style" },
          { value: "light", text: "Light Brand Style" },
          { value: "custom", text: "Custom Image Upload" },
        ]}
        condition={element.options["nav-logo-show"] !== "false"}
        show_reset={element.options["logo-style"] !== null}
      />

      {element.options["nav-logo-show"] !== "false" &&
        element.options["logo-style"] !== "custom" && (
          <div className="row hard-center">
            <div className="col-xs-12">
              <p className="text-base text-black">
                Upload light/dark logos in website{" "}
                <a href={`/websites/${website.id}/edit`} target="_blank">
                  settings →
                </a>
              </p>
            </div>
          </div>
        )}

      <VariantBuilderSetting
        object={element}
        setting_name="[options][logo-image]"
        setting_type="image"
        object_type="elements"
        object_id={element.id}
        label="Custom Image URL"
        value={
          element.options["logo-image"] ? element.options["logo-image"] : null
        }
        placeholder={variant.options["logo-image"]}
        condition={element.options["nav-logo-show"] !== "false"}
        callback={() => {
          builder.update([
            {
              object_type: "elements",
              object_id: element.id,
              setting_name: "[options][logo-style]",
              value: "custom",
            },
          ]);
        }}
      />

      <VariantBuilderSetting
        object={element}
        label="Size control"
        setting_name="[options][control-style]"
        setting_type="dropdown"
        object_type="elements"
        object_id={element.id}
        value={controlStyle}
        options={[
          { value: "width", text: "Width" },
          { value: "height", text: "Height" },
        ]}
        device="desktop"
        condition={element.options["nav-logo-show"] !== "false"}
        show_reset={element.options["control-style"] !== null}
      />

      <VariantBuilderSetting
        object={element}
        label="Size control"
        setting_name="[options][control-style-mobile]"
        setting_type="dropdown"
        object_type="elements"
        object_id={element.id}
        value={controlStyleMobile}
        placeholder={controlStyle}
        options={[
          { value: "width", text: "Width" },
          { value: "height", text: "Height" },
        ]}
        device="mobile"
        condition={element.options["nav-logo-show"] !== "false"}
        show_reset={element.options["control-style-mobile"] !== null}
      />

      <VariantBuilderSetting
        object={element}
        setting_name="[options][image-width]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        label="Logo Width"
        value={element.options["image-width"]}
        device="desktop"
        condition={
          element.options["nav-logo-show"] !== "false" &&
          controlStyle !== "height"
        }
        placeholder={
          variant.options["logo-image-width"]
            ? variant.options["logo-image-width"]
            : 150
        }
        min={0}
        max={2560}
        allow_empty={true}
        range_step={"1"}
        show_reset={true}
      />

      <VariantBuilderSetting
        object={element}
        setting_name="[options][image-width-mobile]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        label="Logo Width"
        condition={
          element.options["nav-logo-show"] !== "false" &&
          controlStyleMobile == "width"
        }
        placeholder={
          element.options["image-width"]
            ? element.options["image-width"]
            : variant.options["logo-image-width"]
            ? variant.options["logo-image-width"]
            : 150
        }
        value={
          element.options["image-width-mobile"]
            ? element.options["image-width-mobile"]
            : undefined
        }
        device="mobile"
        min={0}
        max={2560}
        allow_empty={true}
        range_step={"1"}
        show_reset={true}
      />

      <VariantBuilderSetting
        object={element}
        setting_name="[options][image-height]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        label="Logo Height"
        value={element.options["image-height"]}
        device="desktop"
        condition={
          element.options["nav-logo-show"] !== "false" &&
          controlStyle == "height"
        }
        placeholder={
          variant.options["logo-image-height"]
            ? variant.options["logo-image-height"]
            : "Auto"
        }
        min={0}
        max={2560}
        allow_empty={true}
        range_step={"1"}
        show_reset={true}
      />

      <VariantBuilderSetting
        object={element}
        setting_name="[options][image-height-mobile]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        label="Logo Height"
        condition={
          element.options["nav-logo-show"] !== "false" &&
          controlStyleMobile == "height"
        }
        placeholder={
          element.options["image-height"]
            ? element.options["image-height"]
            : variant.options["logo-image-height"]
            ? variant.options["logo-image-height"]
            : "Auto"
        }
        value={
          element.options["image-height-mobile"]
            ? element.options["image-height-mobile"]
            : undefined
        }
        device="mobile"
        min={0}
        max={2560}
        allow_empty={true}
        range_step={"1"}
        show_reset={true}
      />

      <VariantBuilderSetting
        object={element}
        setting_name="[options][logo-link]"
        setting_type="text"
        object_type="elements"
        object_id={element.id}
        label="Logo Link"
        placeholder={
          variant.options["logo-link"]
            ? variant.options["logo-link"]
            : "https://"
        }
        value={
          element.options["logo-link"]
            ? element.options["logo-link"]
            : undefined
        }
        condition={element.options["nav-logo-show"] !== "false"}
        allow_empty={true}
        show_reset={true}
      >
        <VariantBuilderSetting
          object={element}
          setting_name="[options][logo-link-new-tab]"
          setting_type="checkbox"
          object_type="elements"
          object_id={element.id}
          label="Open in New Tab"
          value={element.options["logo-link-new-tab"]}
          show_reset={true}
          classNames="!w-[250px]"
        />
      </VariantBuilderSetting>

      <VariantBuilderSetting
        object={element}
        setting_name="[options][website-navigation-id]"
        setting_type="dropdown"
        object_type="elements"
        object_id={element.id}
        label="Website Navigation"
        value={selectedNavId ? selectedNavId.toString() : ""}
        placeholder="Select a navigation"
        options={[
          { value: "", text: "Select a navigation" },
          ...Object.values(navigations).map((navigation) => ({
            value: navigation.id.toString(),
            text: navigation.name || `Navigation ${navigation.id}`,
          })),
        ]}
      />

      <div className="row hard-center">
        <div className="col-xs-12">
          <p className="text-base text-black">
            Manage navigations in website{" "}
            <a
              href={`/websites/${website.id}/navigations`}
              target="_blank"
              rel="noreferrer"
            >
              settings →
            </a>
          </p>
        </div>
      </div>

      <div className="col-xs-12 mt-5">
        <div className="w-full relative text-black dark:text-white">
          <span className="font-semibold text-xl">Custom Content:</span>
        </div>
      </div>
      <div
        className="sortable-container col-xs-12"
        data-sortable-name="content-toggle-list-items"
        data-object_type="content_toggle_items"
      >
        {custom_content_items.map((item) => (
          <VariantBuilderSetting
            key={`custom-element-${item.id}`}
            object={item}
            setting_name="[position]"
            setting_type="item_v2"
            object_type="content_toggle_items"
            object_id={item.id}
            title={item.content || "Custom Content"}
            label_icon={"fa-puzzle-piece"}
            label_max_length={40}
            label_hover_max_length={30}
            style={{ margin: "4px 0px" }}
            position={item.position}
            hide_duplicate={true}
            hide_remove={false}
            toggle_setting_name="[options][show]"
            toggle_value={
              item.options && item.options["show"]
                ? item.options["show"]
                : "true"
            }
            panel_type="modal"
            side_panel={true}
            modalTitle={`Settings - ${item.content || "Custom Content"}`}
          >
            <VariantBuilderSetting
              object={item}
              label="Title"
              setting_name="[content]"
              setting_type="text"
              object_type="content_toggle_items"
              object_id={item.id}
              value={item.content || ""}
              placeholder="Custom Content"
            />
          </VariantBuilderSetting>
        ))}
      </div>

      <div className="col-xs-12 my-5">
        <button
          onClick={createCustomContent}
          className="w-full p-2 text-left bg-transparent border-none text-xl text-blue-600 dark:text-blue-200 dark:hover:text-white"
        >
          <FontAwesomeIcon icon="plus-square" className="mr-2 text-2xl" /> Add
          Custom Content
        </button>
      </div>

      <VariantBuilderSetting
        object={element}
        setting_name="[options][nav-hamburger]"
        setting_type="checkbox"
        object_type="elements"
        object_id={element.id}
        label="Hamburger menu on mobile"
        value={
          element.options["nav-hamburger"]
            ? element.options["nav-hamburger"]
            : variant.options["nav-hamburger"]
            ? variant.options["nav-hamburger"]
            : "true"
        }
        device="mobile"
      />
    </React.Fragment>
  );
};

export default ElementSettingsNavigation;
